var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 21.677,
    viewBox: "0 0 32 21.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#7ad7ee;}.b{fill:#4bc3ef;}.c{fill:#1badde;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -82.581)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.693,265.084a1.89,1.89,0,0,0-1.048.088,5.1,5.1,0,0,1-3.67,0A1.917,1.917,0,0,0,9.9,265.09,4.128,4.128,0,0,0,7.648,266.4l-.591,2.729v2.124A1.548,1.548,0,0,0,8.605,272.8H19v-3.672A4.125,4.125,0,0,0,15.693,265.084Z",
    transform: "translate(-6.616 -171.062)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.548,292.489a.516.516,0,0,1-.516-.516v-5.309A4.114,4.114,0,0,0,0,289.393v2.581a1.548,1.548,0,0,0,1.548,1.548h9.29a1.544,1.544,0,0,0,1.454-1.032Z",
    transform: "translate(0 -191.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M64.678,151.227a2.568,2.568,0,0,1-.409,1.394,2.454,2.454,0,0,1-2.172,1.033,2.359,2.359,0,0,1-2.467-2.427,3.283,3.283,0,0,1,1.069-2.17,2.581,2.581,0,0,1,3.978,2.17Z",
    transform: "translate(-55.904 -61.936)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M61.162,159.2a2.582,2.582,0,0,1-2.172-3.976,2.581,2.581,0,1,0,3.57,3.564A2.578,2.578,0,0,1,61.162,159.2Z",
    transform: "translate(-54.194 -68.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M322.867,265.072a1.884,1.884,0,0,0-1.034.092,5.1,5.1,0,0,1-3.666,0,1.884,1.884,0,0,0-1.034-.092,4.125,4.125,0,0,0-3.326,4.046V271.7a1.548,1.548,0,0,0,1.548,1.548h9.29a1.548,1.548,0,0,0,1.548-1.548v-2.581A4.125,4.125,0,0,0,322.867,265.072Z",
    transform: "translate(-294.193 -171.054)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M209.092,86.194a3.6,3.6,0,0,1-.647,2.064,3.418,3.418,0,0,1-2.966,1.309,3.213,3.213,0,0,1-3.368-3.373,3.415,3.415,0,0,1,1.3-2.965,3.613,3.613,0,0,1,5.678,2.965Z",
    transform: "translate(-189.479)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M157.3,232.714a1.437,1.437,0,0,0-1.032.12,6.66,6.66,0,0,1-6.24,0,1.437,1.437,0,0,0-1.032-.12,4.133,4.133,0,0,0-2.041,1.262l-.663,2.731v5.728a2.065,2.065,0,0,0,2.065,2.064h9.954l1.788-.567a2.055,2.055,0,0,0,.276-1.032v-6.194A4.13,4.13,0,0,0,157.3,232.714Z",
    transform: "translate(-137.151 -140.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M142.452,263.552a1.032,1.032,0,0,1-1.032-1.032V253.6a4.12,4.12,0,0,0-1.032,2.731v6.194a2.065,2.065,0,0,0,2.065,2.065h10.323a2.072,2.072,0,0,0,1.788-1.032Z",
    transform: "translate(-131.613 -160.326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M202.707,98.628a3.614,3.614,0,0,1-2.966-5.677,3.613,3.613,0,1,0,5.031,5.028A3.6,3.6,0,0,1,202.707,98.628Z",
    transform: "translate(-185.807 -9.722)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M378.485,151.227a2.568,2.568,0,0,1-.409,1.394,2.454,2.454,0,0,1-2.172,1.033,2.359,2.359,0,0,1-2.467-2.427,3.283,3.283,0,0,1,1.069-2.17,2.581,2.581,0,0,1,3.978,2.17Z",
    transform: "translate(-350.098 -61.936)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M374.968,159.2a2.582,2.582,0,0,1-2.172-3.976,2.581,2.581,0,1,0,3.57,3.564A2.578,2.578,0,0,1,374.968,159.2Z",
    transform: "translate(-348.387 -68.098)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudents);
export default __webpack_public_path__ + "static/media/students.eb3193681274c5b80a5f2a5a558eac21.svg";
export { ForwardRef as ReactComponent };